import { H6 } from '../../../../theme';
import styled from 'styled-components6';

type JobTitleProps = {
    title?: string;
};

const JobTitleContainer = styled(H6)`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const JobTitle = ({ title }: JobTitleProps): JSX.Element => {
    return <JobTitleContainer>{title}</JobTitleContainer>;
};
